import { GET_LEAGUEPLAYERS_LOADING, GET_LEAGUEPLAYERS_SUCCESS, GET_LEAGUEPLAYERS_ERROR } from "../../../constant/actionTypes";

const leaguePlayerReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_LEAGUEPLAYERS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_LEAGUEPLAYERS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case GET_LEAGUEPLAYERS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default leaguePlayerReducer;